import {
	getFeedApiV1AuthFeedGet,
	hideCardApiV1AuthCardsCardIdHidePost,
	postQotdAnswerApiV1AuthFeedQotdAnswerPost,
	recordFeedPageVisitApiV1AnalyticsPageVisitsFeedPost,
	reportCardApiV1AuthCardsCardIdReportPost,
	starCardApiV1AuthCardsCardIdStarPost,
} from "@/shared/api/generated-backend"
import { HttpError } from "@/shared/api/http"
import { captureError } from "@/shared/lib/diagnostics"
import type { FeedList, FeedSort } from "../model/types"

type FeedQuery = {
	limit?: number
	cursor?: string | null
	sort: FeedSort
}

export async function getCardFeed(params: FeedQuery): Promise<FeedList> {
	return getFeedApiV1AuthFeedGet({
		query: params,
	})
}

/** Лента ответов на вопрос дня: `GET /feed?category=qotd`
 * (несёт locked / current_question / user_has_answered + items). */
export async function getDailyQuestionFeed(
	params: FeedQuery,
): Promise<FeedList> {
	return getFeedApiV1AuthFeedGet({
		query: { ...params, category: "qotd" },
	})
}

/** Отправить ответ (1–100 символов). Идемпотентно: повтор → тот же card_id. */
export async function submitDailyQuestionAnswer(answer: string) {
	return postQotdAnswerApiV1AuthFeedQotdAnswerPost({
		body: { answer },
	})
}

/**
 * Поставить звезду карточке ленты или ответу QOD (та же сущность card, см.
 * .team/backend-task-stars.md). 409 (уже стоит) — не ошибка, трактуем как успех.
 */
export async function starCard(cardId: number): Promise<void> {
	try {
		await starCardApiV1AuthCardsCardIdStarPost({
			path: { card_id: cardId },
		})
	} catch (error) {
		if (error instanceof HttpError && error.status === 409) {
			return
		}
		throw error
	}
}

export async function hideCard(cardId: number): Promise<void> {
	await hideCardApiV1AuthCardsCardIdHidePost({
		path: { card_id: cardId },
	})
}

export async function reportCard(cardId: number): Promise<void> {
	await reportCardApiV1AuthCardsCardIdReportPost({
		path: { card_id: cardId },
	})
}

export function recordFeedPageVisit(): void {
	recordFeedPageVisitApiV1AnalyticsPageVisitsFeedPost().catch((error) =>
		captureError(error, { scope: "feed.pageVisit" }),
	)
}
